export enum SelectLTPBlockType {
  singleLTPInfo = 'single-ltp-info',
  fastPaymentButton = 'fast-payment-button',
  paymentModalWindow = 'payment-modal-window',
}
